var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginBgRight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 603,
    height: 700,
    viewBox: "0 0 603 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    width: 515,
    height: 709,
    fill: "#3C3C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M583 723.151C594.598 723.151 604 713.715 604 702.076C604 690.436 594.598 681 583 681C571.402 681 562 690.436 562 702.076C562 713.715 571.402 723.151 583 723.151Z",
    stroke: "#CC9D9D",
    strokeWidth: 5.9576,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M633.184 74.6963L602.736 91.9277L572.454 74.1779L572.618 39.1056L603.111 21.8288L633.348 39.6241L633.184 74.6963Z",
    stroke: "#CC9D9D",
    strokeWidth: 6.5767,
    strokeMiterlimit: 10,
    strokeDasharray: "13.15 13.15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.5 60.5C115.5 63.7795 112.625 66.5 109 66.5C105.375 66.5 102.5 63.7795 102.5 60.5C102.5 57.2205 105.375 54.5 109 54.5C112.625 54.5 115.5 57.2205 115.5 60.5Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M535.5 523.5C535.5 526.779 532.625 529.5 529 529.5C525.375 529.5 522.5 526.779 522.5 523.5C522.5 520.221 525.375 517.5 529 517.5C532.625 517.5 535.5 520.221 535.5 523.5Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.5 545.5C179.5 548.779 176.625 551.5 173 551.5C169.375 551.5 166.5 548.779 166.5 545.5C166.5 542.221 169.375 539.5 173 539.5C176.625 539.5 179.5 542.221 179.5 545.5Z",
    stroke: "white",
    strokeOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBgRight1);
export default __webpack_public_path__ + "static/media/loginBgRight1.a1e3e80ec9272569789dc38883515380.svg";
export { ForwardRef as ReactComponent };